import { createAsyncThunk } from "@reduxjs/toolkit";
import * as API from "./api";

// get documentNumbering
export const getDocumentNumbering = createAsyncThunk(
  "documentNumbering/getDocumentNumbering",
  async (params, { rejectWithValue }) => {
    const { rowsPerPage, search, sortOrder, pageNo } = params;
    try {
      const { data } = await API.getDocumentNumbering({ rowsPerPage: rowsPerPage, search, sortOrder, pageNo });
      return data;
    } catch (error) {
      return rejectWithValue(error?.response?.data?.message);
    }
  }
);

// get all documentNumbering
export const getAllDocumentNumbering = createAsyncThunk(
  "documentNumbering/getAllDocumentNumbering",
  async (_, { rejectWithValue }) => {
    try {
      const { data } = await API.getAllDocumentNumbering();
      return data;
    } catch (error) {
      return rejectWithValue(error?.response?.data?.message);
    }
  }
);

// get previous
export const getPrevious = createAsyncThunk("documentNumbering/getPrevious", async (previous, { rejectWithValue }) => {
  try {
    const { data } = await API.getPrevious(previous);
    return data;
  } catch (error) {
    return rejectWithValue(error?.response?.data?.message);
  }
});
// get next
export const getNext = createAsyncThunk("documentNumbering/getNext", async (next, { rejectWithValue }) => {
  try {
    const { data } = await API.getNext(next);

    return data;
  } catch (error) {
    return rejectWithValue(error?.response?.data?.message);
  }
});

// get particular page
export const getParticularPage = createAsyncThunk(
  "documentNumbering/getParticularPage",
  async (params, { rejectWithValue }) => {
    const { number, rowsPerPage, search } = params;
    try {
      const { data } = await API.getPageDocumentNumbering({ number, rowsPerPage: rowsPerPage, search });
      return data;
    } catch (error) {
      return rejectWithValue(error?.response?.data?.message);
    }
  }
);
// get particular page
export const getDocumentNumberingById = createAsyncThunk(
  "documentNumbering/getDocumentNumberingById",
  async (id, { rejectWithValue }) => {
    try {
      const { data } = await API.getDocumentNumberingById(id);
      return data;
    } catch (error) {
      return rejectWithValue(error?.response?.data?.message);
    }
  }
);

// create documentNumbering
export const createDocumentNumbering = createAsyncThunk(
  "documentNumbering/createDocumentNumbering",
  async (param, { rejectWithValue }) => {
    const {
      branch,
      series,
      prefix,
      suffix,
      firstNumber,
      nextNumber,
      lastNumber,
      lock,
      isActive,
      forInterBranchTransaction,
    } = param;
    try {
      const body = JSON.stringify({
        branch,
        series,
        prefix,
        suffix,
        firstNumber,
        nextNumber,
        lastNumber,
        lock,
        isActive,
        forInterBranchTransaction,
      });
      const { data } = await API.createDocumentNumbering(body);
      return data;
    } catch (error) {
      return rejectWithValue(error?.response?.data);
    }
  }
);
export const updateDocumentNumbering = createAsyncThunk(
  "documentNumbering/updateDocumentNumbering",
  async (param, { rejectWithValue }) => {
    const { id, values } = param;
    const {
      branch,
      series,
      prefix,
      suffix,
      firstNumber,
      nextNumber,
      lastNumber,
      lock,
      isActive,
      forInterBranchTransaction,
    } = values;
    try {
      const body = JSON.stringify({
        branch,
        series,
        prefix,
        suffix,
        firstNumber,
        nextNumber,
        lastNumber,
        lock,
        isActive,
        forInterBranchTransaction,
      });
      const { data } = await API.updateDocumentNumbering(id, body);
      return data;
    } catch (error) {
      return rejectWithValue(error?.response?.data);
    }
  }
);

// handle search
export const handleSearch = createAsyncThunk("documentNumbering/handleSearch", async (param, { rejectWithValue }) => {
  const { search, rowsPerPage } = param;
  try {
    const { data } = await API.handleSearch(search, rowsPerPage);
    return data;
  } catch (error) {
    return rejectWithValue(error?.response?.data?.message);
  }
});
